import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { sendMixPanelEvent } from '../../../../../Utils/mixpanel';
import { ENTER_EMAIL } from '../../../../../Utils/mixpanel/mixpanelEvents';
import * as Translations from '../../../../providers/i18n';

import './style.scss';

const emailRegex = /^([a-zA-Z0-9.\-+_])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
const emailTagSeperator = [32, 13, 188, 186];

class EmailsInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            inputValue: '',
            validEmail: true
        };

        this.onChange = this.onChange.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.addEmail = this.addEmail.bind(this);
        this.deleteEmail = this.deleteEmail.bind(this);
        this.focusInput = this.focusInput.bind(this);
        this.emailValidationHandler = this.emailValidationHandler.bind(this);
        this.onBlur = this.onBlur.bind(this);
    }

    onChange({ target: { value } }) {
        if (!this.state.validEmail) {
            this.setState({
                validEmail: true,
                inputValue: value
            });
        } else {
            this.setState({
                inputValue: value
            });
        }
    }

    onKeyPress(e) {
        if (emailTagSeperator.includes(e.which)) {
            e.preventDefault();

            this.emailValidationHandler();

            this.input.focus();
        }
    }

    emailValidationHandler() {
        const { inputValue } = this.state;

        if (this.validateEmail(inputValue)) {
            this.setState({
                inputValue: ''
            });

            this.addEmail(inputValue);

            sendMixPanelEvent({
                eventName: ENTER_EMAIL
            });
        } else {
            this.setState({
                validEmail: false
            });
        }
    }

    addEmail(email) {
        const newList = [...this.props.emails, email];
        this.props.onChange(newList);
    }

    deleteEmail(index) {
        const newList =  this.props.emails.filter((e, idx) => idx !== index);
        this.props.onChange(newList);
    }

    onBlur() {
        const { inputValue } = this.state;

        if (inputValue) {
            this.emailValidationHandler();
        }
    }

    validateEmail(value) {
        return emailRegex.test(value);
    }

    focusInput() {
        this.input.focus();
    }

    render() {
        const {
            inputValue,
            validEmail
        } = this.state;

        const {
            emails,
            i18n
        } = this.props;

        const text = validEmail ? '' : i18n.t('attachments_preview.invite.invalid_email');
        const validationClasses = classNames('email-description', 'font-accent', { error: !validEmail });
        const placeholder = emails.length ? i18n.t('attachments_preview.invite.add_new_collaborators') : i18n.t('attachments_preview.invite.enter_new_emails');

        return (
            <div className="email-container">
                <h3 className="font-accent">{i18n.t('attachments_preview.invite.add_collaborators_title')}</h3>
                <div className="email-wrapper">
                    <div className="envelope"/>
                    <div className="email-tags font-accent" onClick={this.focusInput}>
                        {emails.map((email, index) => (
                            <span key={index}>
                                {email}
                                <button onClick={() => this.deleteEmail(index)}>&times;</button>
                            </span>
                        ))}
                        <input value={inputValue}
                            placeholder={placeholder}
                            onChange={this.onChange}
                            onKeyPress={this.onKeyPress}
                            onBlur={this.onBlur}
                            ref={(ref) => this.input = ref}/>
                    </div>
                </div>
                <div className={validationClasses}>{text}</div>
            </div>
        );
    }
}

EmailsInput.propTypes = {
    onChange: PropTypes.func,
    emails: PropTypes.array,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

export default Translations.connect(EmailsInput);
